function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    height: 42,
    id: "screenshot-f2f9a4d4-f249-8020-8007-8e81d8a6253c",
    viewBox: "0 0 42 42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-f2f9a4d4-f249-8020-8007-8e81d8a6253c",
    width: 24,
    height: 24,
    rx: 0,
    ry: 0,
    style: {
      fill: "white"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-f2f9a4d4-f249-8020-8007-8e81d8a6253e",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f2f9a4d4-f249-8020-8007-8e81d8a6253e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-f2f9a4d4-f249-8020-8007-8e81d8a67a17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f2f9a4d4-f249-8020-8007-8e81d8a67a17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.60748291015625,12.4775390625L21.85748291015625,3.7275390625C21.330413818359375,3.43133544921875,20.687103271484375,3.43133544921875,20.15997314453125,3.7275390625L4.39251708984375,12.4775390625C3.83251953125,12.79248046875,3.5,13.3699951171875,3.5,14L3.5,17.5C3.5,18.46246337890625,4.28753662109375,19.25,5.25,19.25L8.75,19.25L8.75,31.5L5.25,31.5C4.28753662109375,31.5,3.5,32.28753662109375,3.5,33.25L3.5,36.75C3.5,37.71246337890625,4.28753662109375,38.5,5.25,38.5L36.75,38.5C37.71246337890625,38.5,38.5,37.71246337890625,38.5,36.75L38.5,33.25C38.5,32.28753662109375,37.71246337890625,31.5,36.75,31.5L33.25,31.5L33.25,19.25L36.75,19.25C37.71246337890625,19.25,38.5,18.46246337890625,38.5,17.5L38.5,14C38.498931884765625,13.36865234375,38.1578369140625,12.786865234375,37.60748291015625,12.4775390625M15.75,31.5L12.25,31.5L12.25,19.25L15.75,19.25ZM22.75,31.5L19.25,31.5L19.25,19.25L22.75,19.25ZM21,15.75C19.547515869140625,15.75,18.375,14.5775146484375,18.375,13.125C18.375,11.6724853515625,19.547515869140625,10.5,21,10.5C22.452484130859375,10.5,23.625,11.6724853515625,23.625,13.125C23.625,14.5775146484375,22.452484130859375,15.75,21,15.75M29.75,31.5L26.25,31.5L26.25,19.25L29.75,19.25Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/icon-bank.eebea22dedcbe2ecec689bb349b4bb2f.svg";
export { ForwardRef as ReactComponent };